module.exports = __webpack_public_path__ + "img/safety.199ee732.png";